<template>
  <div class="bgf4">
    <div class="box bgfff" style="display:block;margin:20px auto;padding:20px;">
      <!-- 左侧菜单栏 -->
      <div class="fleft  cleft">
        <!--<div class="firmTitle bgblue">
          <img src="../../images/jt.png">
          <span style="margin-left:10px">咨询服务</span>
        </div>-->
        <ul class="cleftUl">
          <a-menu mode="inline"  class="mezt" :default-selected-keys="openKeys">
            <template  style="display: none;" v-for="item in treeList">
              <a-menu-item class="ali" :key="item.id" @click="cjwtClicke">
                <!-- <a style="color:black" @click="cjwtClicke" >
                  <li class="bgblue" v-if="cjwt">
                    <img  src="../../images/jt.png" class="fleft mr10">
                    <span style="margin-left: 29px">常见问题</span>
                  </li>
                  <span style="margin-right: 20px">常见问题</span>
                </a> -->
                <span>{{item.title}}</span>
              </a-menu-item>
              <!-- <a-menu-item class="ali">
                <a style="color:black"  @click="wyzxClicke">
                  <li class="bgblue" v-if="wyzx">
                    <img  src="../../images/jt.png" class="fleft mr10">
                    <span style="margin-left: 29px">我要咨询</span>
                  </li>
                  <span style="margin-right: 20px">我要咨询</span>

                </a>
              </a-menu-item> -->
            </template>
          </a-menu>
        </ul>
      </div>
      <!-- class=" bgfff"  -->
      <div v-if="zxfw=='cjwt'" >
          <aquatic-zixun />
      </div>
      <div v-if="zxfw=='wyzx'" style="background: #FFFFFF; height: 100%">
        <aquatic-wyzx  />
      </div>
    </div>
  </div>
</template>



<script>
import AquaticZixun from './AquaticZixun'
import AquaticWyzx from './AquaticWyzx'
import http from '../../js/axios'

export default {
  name: 'AquaticZxfw',
  components: {
    AquaticZixun,
    AquaticWyzx
  },
  data(){
    return{
      cjwt:true,
      wyzx:false,
      openKeys:[],
      treeList: [
      ],
      cjwtid:'cjwtid',
      zxfw:'cjwt'
    }
  },
  computed:{},
  created(){
    // this.cjwtClicke();
    // this.query()
    this.queryDict()
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    cjwtClicke(e){
      // this.cjwt=true
      // this.wyzx=false
      for(var i=0;i<this.treeList.length;i++){
        if(e.key==this.treeList[i].id){
          this.zxfw = this.treeList[i].key
        }
      }
    },
    wyzxClicke(e){
      this.cjwt=false
      this.wyzx=true
    },
    query(){
      this.treeList[0]='cjwtid'
        this.openKeys.push(this.treeList[0])
    },
    queryDict(){
      http.get('/queryDictZxfw',{}
      ).then((res) => {
          this.treeList=res.data.result[0].children
          this.openKeys.push(this.treeList[0].id)
      })
    }
  },
}
</script>


<style scoped>
@import "../../config/AquaticZixun.css"

</style>







// WEBPACK FOOTER //
// src/views/aquaticzixun/AquaticZxfw.vue